import { Component, Input } from '@angular/core';

/**
 * A copy of jhipster item-count component with additional params
 */
@Component({
    selector: 'jhi-item-count-custom',
    template: `
		<span class="jhi-item-count">
            <span jhiTranslate="common.showing">Showing</span> {{((page - 1) * itemsPerPage) == 0 ? 1 : ((page - 1) * itemsPerPage + 1)}} -
			{{(page * itemsPerPage) < total ? (page * itemsPerPage) : total}}
            <span class="ms-1" jhiTranslate="common.of">of</span><span data-test="totalCount" class="fw-bold ms-1">{{total}}</span>
                @if (limit && !(+total < limit)) {
                    <span>+</span>
                }
            <span class="ms-1" jhiTranslate="common.items"></span>
        </span>`,
    styles: [
        `
            .jhi-item-count {
                white-space: pre-wrap;
            }
        `
    ]
})
export class ItemCountCustomComponent {

    @Input() page: number;
    @Input() total: number;
    @Input() limit: number;
    @Input() itemsPerPage: number;

    constructor() {
    }

}
